// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes leters {
  0% {
    opacity: 0;
    transform: rotateY(90deg);
    filter: blur(10px);
  }
  100% {
    opacity: 1;
    transform: rotateY(0deg);
    filter: blur(0);
  }
}
.loader {
  display: flex;
  flex-direction: column;
  margin: 20px auto;
  position: relative;
  width: 14vw;
  height: 14vh;
  background: #e4ffff;
  border-radius: 0.5rem;
  overflow: hidden;
  align-items: center;
  padding-bottom: 150px;
}
.loader::after {
  content: "";
  position: absolute;
  width: 16vw;
  height: 11vh;
  background-image: conic-gradient(transparent, transparent, transparent, #64c4e0);
  animation: animate 4.5s linear infinite;
  animation-delay: 2s;
}
.loader::before {
  content: "";
  position: absolute;
  width: 16vw;
  height: 11vh;
  background-image: conic-gradient(transparent, transparent, transparent, #2c53a0);
  animation: animate 4.5s linear infinite;
}
.loader img {
  z-index: 10;
}
.loader span {
  position: absolute;
  inset: 5px;
  border-radius: 0.5rem;
  background: #e4ffff;
  z-index: 1;
}
.loader h6 {
  color: #64c4e0;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  transform: translateY(-50%);
  font-size: 2em;
  position: relative;
  z-index: 10;
  margin-top: 5%;
  letter-spacing: 0.3rem;
}
.loader h6 span {
  opacity: 1;
  display: inline-block;
  animation: leters 1s linear forwards;
}
.loader h6 span:nth-child(1) {
  animation-delay: 1s;
  color: #2c53a0;
}
.loader h6 span:nth-child(2) {
  animation-delay: 2s;
  color: #2c53a0;
}
.loader h6 span:nth-child(3) {
  animation-delay: 2.75s;
  color: #2c53a0;
}
.loader h6 span:nth-child(4) {
  animation-delay: 3s;
  color: #2c53a0;
}
.loader h6 span:nth-child(5) {
  animation-delay: 3s;
  color: #2c53a0;
}
.loader h6 span:nth-child(6) {
  animation-delay: 3s;
  color: #2c53a0;
}
.loader h6 span:nth-child(7) {
  animation-delay: 2.75s;
  color: #2c53a0;
}
.loader h6 span:nth-child(8) {
  animation-delay: 2s;
  color: #2c53a0;
}
.loader h6 span:nth-child(9) {
  animation-delay: 1s;
  color: #2c53a0;
}
.loader h6 img {
  object-fit: cover;
}
@media (max-width: 600px) {
  .loader {
    width: 29vw;
    height: 6vh;
  }
  .loader::before, .loader::after {
    width: 25vw;
    height: 8vh;
  }
  .loader img {
    width: 50%;
  }
  .loader h6 {
    font-size: 1rem;
    letter-spacing: 0;
  }
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Fuel/loader/nitroLoader.scss"],"names":[],"mappings":"AAIA;EACI;IACI,UAAA;IACA,yBAAA;IACA,kBAAA;EAHN;EAKE;IACI,UAAA;IACA,wBAAA;IACA,eAAA;EAHN;AACF;AAMA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAtBS;EAuBT,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAJJ;AAKI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gFAAA;EAMA,uCAAA;EACA,mBAAA;AARR;AAUI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gFAAA;EAMA,uCAAA;AAbR;AAeI;EACI,WAAA;AAbR;AAeI;EACI,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,mBA7DK;EA8DL,UAAA;AAbR;AAeI;EACI,cAnEK;EAoEL,WAAA;EACA,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAbR;AAcQ;EACI,UAAA;EACA,qBAAA;EACA,oCAAA;AAZZ;AAcY;EACI,mBAAA;EACA,cAnFJ;AAuEZ;AAcY;EACI,mBAAA;EACA,cAvFJ;AA2EZ;AAcY;EACI,sBAAA;EACA,cA3FJ;AA+EZ;AAcY;EACI,mBAAA;EACA,cA/FJ;AAmFZ;AAcY;EACI,mBAAA;EACA,cAnGJ;AAuFZ;AAcY;EACI,mBAAA;EACA,cAvGJ;AA2FZ;AAcY;EACI,sBAAA;EACA,cA3GJ;AA+FZ;AAcY;EACI,mBAAA;EACA,cA/GJ;AAmGZ;AAcY;EACI,mBAAA;EACA,cAnHJ;AAuGZ;AAeQ;EACI,iBAAA;AAbZ;AAgBI;EA1GJ;IA2GQ,WAAA;IACA,WAAA;EAbN;EAcM;IAEI,WAAA;IACA,WAAA;EAbV;EAeM;IACI,UAAA;EAbV;EAeM;IACI,eAAA;IACA,iBAAA;EAbV;AACF;;AAiBA;EACI;IACI,uBAAA;EAdN;EAgBE;IACI,yBAAA;EAdN;AACF","sourcesContent":["$nitroLight: #64c4e0;\n$nitroDark: #2c53a0;\n$background: #e4ffff;\n\n@keyframes leters {\n    0% {\n        opacity: 0;\n        transform: rotateY(90deg);\n        filter: blur(10px);\n    }\n    100% {\n        opacity: 1;\n        transform: rotateY(0deg);\n        filter: blur(0);\n    }\n}\n\n.loader {\n    display: flex;\n    flex-direction: column;\n    margin: 20px auto;\n    position: relative;\n    width: 14vw;\n    height: 14vh;\n    background: $background;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    align-items: center;\n    padding-bottom: 150px;\n    &::after {\n        content: \"\";\n        position: absolute;\n        width: 16vw;\n        height: 11vh;\n        background-image: conic-gradient(\n            transparent,\n            transparent,\n            transparent,\n            $nitroLight\n        );\n        animation: animate 4.5s linear infinite;\n        animation-delay: 2s;\n    }\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 16vw;\n        height: 11vh;\n        background-image: conic-gradient(\n            transparent,\n            transparent,\n            transparent,\n            $nitroDark\n        );\n        animation: animate 4.5s linear infinite;\n    }\n    img {\n        z-index: 10;\n    }\n    span {\n        position: absolute;\n        inset: 5px;\n        border-radius: 0.5rem;\n        background: $background;\n        z-index: 1;\n    }\n    h6 {\n        color: $nitroLight;\n        width: 100%;\n        display: flex;\n        justify-content: space-evenly;\n        transform: translateY(-50%);\n        font-size: 2em;\n        position: relative;\n        z-index: 10;\n        margin-top: 5%;\n        letter-spacing: 0.3rem;\n        span {\n            opacity: 1;\n            display: inline-block;\n            animation: leters 1s linear forwards;\n\n            &:nth-child(1) {\n                animation-delay: 1s;\n                color: $nitroDark;\n            }\n            &:nth-child(2) {\n                animation-delay: 2s;\n                color: $nitroDark;\n            }\n            &:nth-child(3) {\n                animation-delay: 2.75s;\n                color: $nitroDark;\n            }\n            &:nth-child(4) {\n                animation-delay: 3s;\n                color: $nitroDark;\n            }\n            &:nth-child(5) {\n                animation-delay: 3s;\n                color: $nitroDark;\n            }\n            &:nth-child(6) {\n                animation-delay: 3s;\n                color: $nitroDark;\n            }\n            &:nth-child(7) {\n                animation-delay: 2.75s;\n                color: $nitroDark;\n            }\n            &:nth-child(8) {\n                animation-delay: 2s;\n                color: $nitroDark;\n            }\n            &:nth-child(9) {\n                animation-delay: 1s;\n                color: $nitroDark;\n            }\n        }\n        img {\n            object-fit: cover;\n        }\n    }\n    @media (max-width: 600px) {\n        width: 29vw;\n        height: 6vh;\n        &::before,\n        &::after {\n            width: 25vw;\n            height: 8vh;\n        }\n        img {\n            width: 50%;\n        }\n        h6 {\n            font-size: 1rem;\n            letter-spacing: 0;\n        }\n    }\n}\n\n@keyframes animate {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
